const getListTypes = (listName: string) => ({
  RECEIVED_LIST_TYPE: `${listName}:RECEIVED_LIST_TYPE`,
  REFRESHING_LIST_TYPE: `${listName}:REFRESHING_LIST_TYPE`,
  REFRESH_LIST_ERROR: `${listName}:REFRESH_LIST_ERROR`,
  RESET_LIST: `${listName}:RESET_LIST`,
});

export default getListTypes;
